<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t('log_line_notification.head') }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t('log_line_notification.head_list') }} </v-card-title>
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>
            <span>
              <date-picker-input :label="$t('log_line_notification.date_from')" :date="dateFrom"
                @setValue="dateFrom = $event" />
            </span>
            <span>
              <date-picker-input :label="$t('log_line_notification.date_to')" :date="dateTo"
                @setValue="dateTo = $event" />
            </span>
            <v-btn color="primary" class="" @click="dataSearch"> {{ $t('search') }} </v-btn>
          </v-row>
        </v-card-actions>
        <v-card-actions>
          <v-spacer />
          <span class="px-3 mt-5">{{ $t('search') }}:</span>
          <div style="width: 150px" class="mt-5">
            <v-text-field v-debounce:500ms="searchKeyword" :date="searchData" outlined dense hide-details />
          </div>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :items="logs"
            :no-data-text="$t('not_found')" :no-results-text="$t('not_found')" :options.sync="pagination"
            :server-items-length="pagination.totalItems" :items-per-page="pagination.rowsPerPage"
            :page.sync="pagination.page" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :loading="loading" :search="search">
            <template v-slot:[`item.status`]="{ item }">
              <div v-if="item.status === 'success'" class="success--text">{{ $t('log_line_notification.status1') }}</div>
              <div v-if="item.status === 'fail'" class="error--text">{{ $t('log_line_notification.status2') }}</div>
              <div v-if="item.status === 'pending'" class="warning--text">{{ $t('log_line_notification.status3') }}</div>
            </template>
            <template v-slot:[`item.type`]="{ item }">
              <div v-if="item.type === 'withdraw'" class="success--text">
                <v-icon color="success" small>mdi-arrow-up</v-icon>
                {{ $t('deposit') }}
              </div>
              <div v-if="item.type === 'deposit'" class="error--text">
                <v-icon color="error" small>mdi-arrow-down</v-icon>
                {{ $t('withdraw') }}
              </div>
              <div v-if="item.type === 'newMember'" class="primary--text">
                <v-icon color="primary" small>mdi-account-plus</v-icon>
                {{ $t('log_line_notification.register') }}
              </div>
              <div v-if="item.type === 'other'" class="warning--text">
                <v-icon color="warning" small>mdi-card-bulleted-outline</v-icon>
                {{ $t('log_line_notification.other') }}
              </div>
              <div v-if="item.type === 'report'" class="info--text">
                <v-icon color="info" small>mdi-chart-bar</v-icon>
                {{ $t('log_line_notification.daily_report') }}
              </div>
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              <span>{{ formatDate(item.created_at) }}</span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="warning" dark v-bind="attrs" v-on="on"> {{ $t('detail') }} </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>{{ item.response }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import store from '@/store'
export default {
  components: {
    DatePickerInput,
    SelectInput,
  },

  data() {
    return {
      menu: false,
      showDetail: false,
      toggle_exclusive: 0,
      dateFrom: moment().subtract(3, 'days').format('YY-MM-DD'),
      dateTo: moment().format('YY-MM-DD'),
      date: null,
      currentMemberDetail: {},
      searchData: null,
      headers: [
        {
          text: '#',
          value: 'id',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('log_line_notification.header1'),
          value: 'message',
          align: 'center',
          width: '480px',
          sortable: false,
        },

        {
          text: this.$t('log_line_notification.header2'),
          value: 'status',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('log_line_notification.header3'),
          value: 'type',
          width: '50px',
          align: 'center',
          sortable: false,
        },
        // {
        //   text: 'reponse',
        //   value: 'action',
        //   align: 'center',
        //   sortable: false,
        // },
        {
          text: this.$t('log_line_notification.header4'),
          value: 'created_at',
          align: 'center',
          sortable: false,
        },
      ],
      logs: [],
      search: '',
      loading: false,
      dummy: true,
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
    }
  },
  async created() {
    this.addLogPage()
    try {
      // const result = await this.getLogLineNotifyData(`page=1&row=${this.pagination.rowsPerPage}`)
      // this.pagination.totalItems = result.count
      // this.logs = result.data
    } catch (e) { }
  },
  watch: {
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        if (cont && !this.dummy) {
          this.loading = true
          const params = this.searchData ?
            `page=${newValue.page}&rows=${newValue.itemsPerPage}&time_from=${this.formatDateYYYY(this.dateFrom)}&time_to=${this.formatDateYYYY(this.dateTo)}&search=${this.searchData}` :
            `page=${newValue.page}&rows=${newValue.itemsPerPage}&time_from=${this.formatDateYYYY(this.dateFrom)}&time_to=${this.formatDateYYYY(this.dateTo)}`
          const result = await this.getLogLineNotifyData(params)
          this.logs = result.data
          this.pagination.totalItems = result.count
          this.loading = false
        }
        if (cont && this.dummy) {
          this.loading = true
          const params = this.searchData ?
            `page=${newValue.page}&rows=${newValue.itemsPerPage}&time_from=${this.formatDateYYYY(this.dateFrom)}&time_to=${this.formatDateYYYY(this.dateTo)}&search=${this.searchData}` :
            `page=${newValue.page}&rows=${newValue.itemsPerPage}&time_from=${this.formatDateYYYY(this.dateFrom)}&time_to=${this.formatDateYYYY(this.dateTo)}`
          const result = await this.getLogLineNotifyData(params)
          this.logs = result.data
          this.pagination.totalItems = result.count
          this.loading = false
        }
      },
      deep: true,
    },
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'Logs Line notify',
            url: window.location.href,
            detail: 'รายการ Logs Line notify',
            admin: userSystem.name ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    linkTo(link) {
      window.open(link)
    },
    async dataSearch() {
      this.loading = true
      this.dummy = false;
      const params = this.searchData ?
        `page=1&rows=${this.pagination.itemsPerPage}&time_from=${this.formatDateYYYY(this.dateFrom)}&time_to=${this.formatDateYYYY(this.dateTo)}&search=${this.searchData}` :
        `page=1&rows=${this.pagination.itemsPerPage}&time_from=${this.formatDateYYYY(this.dateFrom)}&time_to=${this.formatDateYYYY(this.dateTo)}`
      const result = await this.getLogLineNotifyData(params)
      this.pagination.totalItems = result.count
      this.logs = result.data
      this.pagination.page = 1
      this.loading = false
    },
    async getLogLineNotifyData(params) {
      try {
        return await this.$store.dispatch('getLogLineNotify', params)
      } catch (e) {
        throw e
      }
    },
    async searchKeyword(value) {
      this.dummy = true;
      this.searchData = value
      this.loading = true
      try {
        let result = {}
        if (value) {
          result = await this.getLogLineNotifyData(`page=1&rows=${this.pagination.rowsPerPage}&search=${value}`)
        } else {
          result = await this.getLogLineNotifyData(`page=1&rows=${this.pagination.rowsPerPage}`)
        }
        this.pagination.totalItems = result.count
        this.logs = result.data
      } catch (e) {
        if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
          this.$swal.fire({
            icon: 'error',
            title: e.message,
          })
        }
      }
      this.pagination.page = 1
      this.loading = false
    },
    formatDate(date) {
      return moment(date).format('YY-MM-DD HH:mm')
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
}
</script>
